<template>
    <!-- 继续率配置 -->
    <div class="main-container appointment" style="padding-top:5px">
        <div class="search-box">
            <div class="input-item">
                <span class="label">继续率对象</span>
                <Select v-model="searchParams.supplierType" @on-change="getSelectList" :transfer="true">
                    <Option v-for="(item, i) in owerTypeList" :key="i" :value="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <div class="input-item">
                <span class="label">统计对象</span>
                <Select v-model="searchParams.target" @on-change="val => {
                    val == 2 ? getProductList() : '';
                }
                    " :transfer="true">
                    <Option value="1">整体继续率</Option>
                    <Option value="2">产品继续率</Option>
                </Select>
            </div>
            <div class="input-item">
                <span class="label">继续率月份</span>
                <DatePicker transfer :options="options" format="yyyy-MM" type="month" :value="searchParams.date"
                    @on-change="datePick" clearable placeholder="请选择">
                </DatePicker>
            </div>
            <div v-if="(type == 3 || type == 2 || type == 5) && searchParams.supplierType != 'all'" class="input-item">
                <span v-if="searchParams.supplierType == 1" class="label">保险公司</span>
                <span v-else-if="searchParams.supplierType == 2" class="label">通道公司</span>
                <Select v-model="searchParams.supplierId" :transfer="true" filterable clearable>
                    <Option v-for="(item, i) in selList" :key="i" :value="item.id">{{ item.name }}</Option>
                </Select>
            </div>
            <div class="input-item">
                <span class="label">继续率指标</span>
                <Select v-model="searchParams.calculate" :transfer="true">
                    <Option v-for="item in calculateList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <div class="input-item" v-if="type == 2 || type == 3 || type == 5">
                <span class="label" v-if="type == 2 || type == 5">包含下级机构数据</span>
                <span class="label" v-else-if="type == 3">包含下级团队数据</span>
                <Select v-model="searchParams.hasSubOrg" :transfer="true" @on-change="search" >
                    <Option value="0">否</Option>
                    <Option value="1">是</Option>
                </Select>
            </div>
            <div class="input-item" v-if="searchParams.target == 2">
                <span class="label">产品名称</span>
                <Select v-model="searchParams.productCode" :transfer="true" clearable filterable>
                    <Option v-for="item in productList" :key="item.value" :value="item.productCode">{{ item.productName }}
                    </Option>
                </Select>
            </div>
            <div class="btn-item">
                <Button type="primary" @click="search">搜索</Button>
                <Button type="primary" ghost @click="resetSearch()">重置</Button>
                <Button type="warning" @click="exportExcel()">导出</Button>
            </div>
        </div>
        <div class="table-box">
            <loading :isShow="listLoading" />
            <Table :columns="columns" :data="tableData">
                <template slot-scope="{ row }" slot="rateMode">
                    <Tooltip transfer @on-popper-show="getDetail(row)" max-width="600" theme="light">
                        <span style="cursor: pointer;">
                            <span>{{ row.rateMode == 1 ? '年度' : '月度' }}</span>
                            <template v-if="row.calculateIndex == 1">R13</template>
                            <template v-else-if="row.calculateIndex == 2">R25 </template>
                            <template v-else-if="row.calculateIndex == 3">R37</template>
                            <template v-else>R49</template>
                            <Icon type="ios-help-circle-outline" />
                        </span>

                        <div slot="content">
                            <configDetail :detail="continuityConfigDetail" :item="row" />
                        </div>
                    </Tooltip>
                </template>
                <!-- <template slot-scope="{ row }" slot="action">
                    <span class="table-btn" @click="$refs.configModal.open(type, row)">设置</span>
                </template> -->
            </Table>
        </div>
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList"
            style="text-align: center" />

        <!-- 启动、重启计算率计算 弹窗 -->
        <calculate-modal ref="calculateModal" :searchParams="searchParams" @success="calcList" />
    </div>
</template>

<script>
import dayjs from 'dayjs';
import { pageTool } from '@/api/mixins';
import { config } from './index.config.js';
import selectTree from '@/components/system/selectTree';
import selectTree2 from '@/components/commons/selectTree';
import selectTree3 from '@/components/system/selectTree3';
import calculateModal from './components/calculateModal';
import configDetail from './components/configDetail';
export default {
    mixins: [pageTool, config],
    components: {
        calculateModal,
        selectTree,
        selectTree2,
        selectTree3,
        configDetail
    },
    props: {},
    data() {
        return {
            options: {
                disabledDate(date) {
                    return dayjs(date).isAfter(dayjs()); // false
                }
            },
            continuityConfigDetail: {}, //继续率配置
            type: '', //继续率统计类型 1、保司 2、机构 3、团队 4、个人 5、渠道'
            loading: false,
            selList: [],
            owerTypeList: [], //继续率对象
            productList: [], //产品列表
            secondTree: [],
            groupId: [], //团队
            platList: [], //渠道
            pageName: ''
        };
    },
    watch: {},
    computed: {},
    created() {
        this.type = this.$route.query.type; //1 上游 2机构 3团队 4个人 5渠道
        this.pageName = this.$route.name;
        this.owerTypeList = this.setOwerTypeList(this.type);
        this.searchParams = this.setSearchParams(this.type);
    },
    activated() {
        this.init();
    },
    mounted() { },
    methods: {
        //导出 
        exportExcel(apiPermissionCode) {
            this.isLoading = true;
            let params = JSON.parse(JSON.stringify(this.searchParams));
            this.setListParams(params);
            this.$http({
                url: '/buz/continuityRateRecord/export',
                type: 'POST',
                responseType: 'blob',
                data: params,
                apiPermissionCode
            })
                .then(res => {
                    this.isLoading = false;
                    this.$units.daochu(res);
                })
                .catch(e => {
                    this.isLoading = false;
                });
        },
        //重启、启动继续率计算 重新搜索
        calcList(res) {
            this.search();
        },
        /**
         *
         * @param {Stirng} type 跳转类型 1 承保保费 2实收保费 3上一年度实收保费
         * @param {object} row 当前选项数据
         */
        goPolicyList(type, row) {
            let query = {
                id: row.id,
                type: type,
                year: row.year,
                month: row.month,
                owerId: row.owerId,
                routerType: this.type, //继续率统计类型 1、保司 2、机构 3、团队 4、个人 5、渠道'
                owerType: this.searchParams.owerType,
                owerName: row.owerName,
                rateMode: row.rateMode,
                calculateIndex: row.calculateIndex,
                supplierType: this.searchParams.supplierType != 'all' ? this.searchParams.supplierType : '',
                supplierId: this.searchParams.supplierType != 'all' ? row.supplierId : this.searchParams.supplierId
            };
            if (this.searchParams.target == 2) {
                query.productName = row.productName;
                query.productCode = row.productCode;
            }
            if (this.type != 1) {
                if (this.searchParams.supplierType == 1) {
                    //保司
                    query.companyName = row.companyName;
                } else if (this.searchParams.supplierType == 2) {
                    //通道
                    query.channelName = row.channelName;
                }
            }
            if (type == 1) {
                //承收
                query.insureTimeEnd = row.insureTimeEnd.substring(0, 10);
                query.insureTimeBegin = row.insureTimeBegin.substring(0, 10);
            } else if (type == 2) {
                //实收
                query.receiptTimeBegin = row.receiptTimeBegin.substring(0, 10);
                query.receiptTimeEnd = row.receiptTimeEnd.substring(0, 10);
            } else if (type == 3) {
                //上一年度
                query.lastReceiptTimeBegin = row.lastReceiptTimeBegin ? row.lastReceiptTimeBegin.substring(0, 10) : '';
                query.lastReceiptTimeEnd = row.lastReceiptTimeEnd ? row.lastReceiptTimeEnd.substring(0, 10) : '';
            }
            if (this.type == 2) {
                query.hasSubOrg = this.searchParams.hasSubOrg;
            } else if (this.type == 3) {
                query.hasSubOrg = this.searchParams.hasSubOrg;
                query.groupByType = this.searchParams.groupByType;
                query.groupName = row.groupName;
                query.groupId = row.groupId; //团队id
            } else if (this.type == 4) {
                query.groupByType = this.searchParams.groupByType;
                query.salesManName = row.salesManName;
                query.salesManId = row.salesManId;
                query.salesManCode = row.salesManCode;
            } else if (this.type == 5) {
                query.hasSubOrg = this.searchParams.hasSubOrg;
                query.topOrgName = row.topOrgName;
            }
            this.$router.push({
                path: '/renewalManage/continuityRate/policyList',
                query
            });
        },
        /**
         *
         * @param {String} type 0 启动 1重启
         */
        startCalc(type) {
            //参数2 启动 重启
            this.$refs.calculateModal.open(this.searchParams.owerType);
        },
        resetSearch() {
            this.searchParams = this.setSearchParams(this.type);
            this.getColumns();
            this.searchAjax();
        },
        changeSupplierType(res) {
            //删除
            let idx1 = this.columns.findIndex(i => i.key === 'companyName'); //插入位置
            if (idx1 != -1) {
                this.editColumns(0, idx1);
            }
            let idx2 = this.columns.findIndex(i => i.key === 'channelName'); //插入位置
            if (idx2 != -1) {
                this.editColumns(0, idx2);
            }
            if (!res || res == 'all') return;
            let data = {
                //插入数据
                title: res == 1 ? '保险公司' : '通道公司',
                key: res == 1 ? 'companyName' : 'channelName',
                minWidth: 140,
                align: 'center'
            };
            let type = 1; //0 删除 1 插入
            let idx = 0;
            if (this.type == 4) {
                idx = this.columns.findIndex(i => i.slot === 'rateMode'); //插入位置
            } else {
                idx = this.columns.findIndex(i => i.key === 'hasSubOrg'); //插入位置
            }
            this.editColumns(type, idx, data);
            this.getSelectList(res);
        },
        /**
         *
         *
         * @param {String} res 统计对象类型
         */
        changeTarget(res) {
            //统计对象选择产品继续率时最后方出现查询项产品
            if (res == 2) {
                this.getProductList();
                let data = {
                    //插入数据
                    title: '产品',
                    key: 'productName',
                    minWidth: 140,
                    align: 'center'
                };
                let type = 1; //0 删除 1 插入
                let idx = this.columns.findIndex(i => i.slot === 'rateMode'); //插入位置
                this.editColumns(type, idx, data);
            } else {
                //删除
                let type = 0; //0 删除 1 插入
                let idx = this.columns.findIndex(i => i.key === 'productName'); //插入位置
                this.editColumns(type, idx);
            }
        },
        /**
         *
         * @param {String} type 操作类型 0 删除 1 插入
         * @param {number} idx 操作数组索引
         * @param {object | null} data 插入对象,删除时传null
         */
        editColumns(type, idx, data) {
            if (idx == -1) return;
            if (type == 1) {
                this.columns.splice(idx, 0, data);
            } else {
                this.columns.splice(idx, 1);
            }
        },
        /**
         *
         * @param {*} row 当前项
         * 获取当前项继续率配置
         */
        getDetail(row) {
            this.$http({
                url: '/buz/continuityConfigDetail/read/detail',
                type: 'GET',
                data: {
                    id: row.configDetailId
                }
            }).then(res => {
                if (res.data.netReceipts) {
                    res.data.netReceipts = res.data.netReceipts.split(',');
                }
                if (res.data.underwrite) {
                    res.data.underwrite = res.data.underwrite.split(',');
                }
                console.log(res.data);
                this.continuityConfigDetail = res.data;
            });
        },
        datePick(res) {
            if (res) {
                this.searchParams.year = res.split('-')[0];
                this.searchParams.month = res.split('-')[1];
                this.searchParams.date = new Date(res);
            } else {
                this.searchParams.year = '';
                this.searchParams.month = '';
            }
        },
        search() {
            this.getColumns();
            this.searchAjax();
        },
        init() {
            this.tableData = [];
            this.getColumns();
            if (this.type == 1) {
                this.getSelectList(this.searchParams.owerType);
            } else if (this.type == 2 || this.type == 4) {
                //初始化机构列表，机构继续率默认不展示 保司和通道
                this.$nextTick(() => {
                    this.$refs.selectTreeRef1 && this.$refs.selectTreeRef1.openChange();
                });
            } else if (this.type == 3) {
                //初始化机构列表，机构继续率默认不展示 保司和通道
                this.$nextTick(() => {
                    this.$refs.selectTreeRef2 && this.$refs.selectTreeRef2.openChange();
                });
            } else if (this.type == 5) {
                this.getPlatList();
            }
            this.initListAjax('/buz/continuityRateRecord/read/list');
        },
        getProductList() {
            this.$http({
                url: '/buz/productBase/read/array',
                type: 'POST',
                data: {
                    companyId: this.searchParams.owerId
                }
            }).then(res => {
                this.productList = res.data;
            });
        },
        // 转化参数
        setListParams(params) {
            params.rateMode = this.calculateList[params.calculate - 1].rateMode;
            params.calculateIndex = this.calculateList[params.calculate - 1].calculateIndex;
            if (this.groupId) {
                params.groupIds = this.groupId.map(i => i.id);
            }
            params.calculateType = params.calculateType == 'all' ? '' : params.calculateType;
            params.supplierType = params.supplierType == 'all' ? '' : params.supplierType;
        },
        /**
         * 获取渠道
         */
        getPlatList() {
            this.$http({
                url: '/buz/organizationBase/read/list',
                type: 'POST',
                data: { platformType: 2, pageNo: 1, pageSize: 999 }
            }).then(res => {
                this.platList = res.data;
            });
        },
        /**
         *
         * @param {stirng | number} res 继续率对象 1 保司 2 通道
         */
        getSelectList(res = null) {
            if (res == null || res == 'all') return;
            let url = '';
            let data = {};
            if (res == 1) {
                url = '/buz/insuranceCompany/read/list';
                data = {
                    // hasCovenant: 1
                };
            } else if (res == 2) {
                url = '/buz/insuranceChannel/read/list';
                data = {
                    // hasCovenant: 1
                };
            }
            this.$http({
                url,
                type: 'POST',
                data
            }).then(res => {
                this.selList = res.data;
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import './index.scss';

.ivu-icon-ios-help-circle-outline {
    font-size: 18px;
    margin-left: 5px;
    font-weight: 600;
    transform: translateY(1px);
}

/deep/.ivu-select-selection {
    border-radius: 2px;
}

.sales-wrap {
    .ivu-input-wrapper {
        margin-right: 10px;
    }
}

/deep/.group-wrap {
    .ivu-select-selection {
        margin-right: 10px;
    }
}
</style>
